import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RootState } from '../../application/store';
import { initCustomer } from '../../slices/Customer/customerSlice';

import { Select, Switch } from 'antd'; // <-- aggiungi
import { CustomerFacility, CustomerSummary } from '../../api-client';
import { useCustomerOrders } from '../../common/hooks/useCustomerOrders';
import { useBookedForSales } from './hooks/useBookedForSales';
import { useCustomers } from './hooks/useCustomers';

import './customers-page.scss';

import BVApplicationTemplate from '../../common/templates/BVApplicationTemplate/bv-application-template';
import { initSalesGroup } from '../../slices/System/systemSlice';
import BVCustomersGroup from './components/BVCustomersGroup/bv-customers-group';
import BVOrdersGroup from './components/BVOrdersGroup/bv-orders-group';

interface ICustomersPage {
	handleCustomersSummary: (bvSalesAgent: string) => void;
	customersSummary: CustomerSummary[] | null;
	customersSummaryLoading: boolean;
	handleCustomersSummaryByFilters: (dataFilters: any) => void;
	customersSummaryByFilters: CustomerSummary[] | null;
	customersSummaryByFiltersLoading: boolean;
	handleCustomer: (id: string) => void;
	customer: CustomerSummary | null;
	customerLoading: boolean;
	handleFacilities: (customerId: string) => void;
	facilities: CustomerFacility[] | null;
	facilitiesLoading: boolean;

	handleOrdersSummary: (params: any) => void;
	ordersSummaryLoading: boolean;

	handleEvents: () => void;

	selectedEventId: string;
}

const CustomersPage: React.FunctionComponent = (props) => {
	const {
		handleCustomersSummary,
		customersSummary,
		customersSummaryLoading,
		handleCustomersSummaryByFilters,
		customersSummaryByFilters,
		customersSummaryByFiltersLoading,
		handleCustomer,
		customer,
		customerLoading,
		handleFacilities,
		facilities,
		facilitiesLoading,
		handleEvents,
		events,
		eventsLoading,
		//ADMIN
		handleSalesGroup,
		salesGroups,
		salesGroupsLoading,
	} = useCustomers();

	const { handleOrdersSummary, ordersSummaryLoading } = useCustomerOrders();
	const {
		handleBookForSales,
		bookedForSalesProducts,
		bookedForSalesProductsLoading,
		customerBookedForSalesEventRecap,
		customerBookedForSalesEventRecapLoading,
	} = useBookedForSales();

	const [dataFilter, setDataFilter] = useState<any>({});
	const [impersonateSalesGroup, setImpersonateSalesGroup] = useState(false);
	const [selectedGroup, setSelectedGroup] = useState<string>();
	const bvSalesAgent = useSelector(
		(state: RootState) => state.system.salesAgent,
	);
	const isAdmin = useSelector((state: RootState) => state.system.isAdmin);
	const bvSalesGroup = useSelector(
		(state: RootState) => state.system.salesGroup,
	);
	const showEventFilter = useSelector(
		(state: RootState) => state.eventFilter.showEventFilter,
	);
	const selectedEvent = useSelector(
		(state: RootState) => state.eventFilter.selectedEvent,
	);

	useEffect(() => {
		if (!bvSalesGroup || bvSalesGroup === '') return;
		setImpersonateSalesGroup(true);
		setSelectedGroup(bvSalesGroup);
	}, [bvSalesGroup]);

	useEffect(() => {
		if (isAdmin) handleSalesGroup();
	}, [isAdmin]);

	useEffect(() => {
		const customerFilter = {
			bookedForSales: showEventFilter && !isNaN(parseInt(selectedEvent)),
			eventId: parseInt(selectedEvent),
		};
		handleCustomersSummary(bvSalesAgent, customerFilter, bvSalesGroup);
		handleEvents();
	}, [bvSalesAgent, selectedEvent, showEventFilter, bvSalesGroup]);

	useEffect(() => {
		handleCustomersSummaryByFilters(dataFilter);
	}, [customersSummary, dataFilter]);

	const useQuery = () => {
		return new URLSearchParams(useLocation().search);
	};

	const queryProvider = useQuery();

	const dispatch = useDispatch();

	const refreshBookedForSales = () => {
		if (
			showEventFilter &&
			selectedEvent &&
			customersSummary &&
			customersSummary.length > 0
		) {
			let _defaultCustomer = _.orderBy(
				customersSummary,
				(entry) => entry.fullName,
				'asc',
			)[0];
			let _findingCustomer = _.find(
				customersSummary,
				(entry) => entry.sapCode === queryProvider.get('customer'),
			);

			let customerId = _findingCustomer
				? _findingCustomer.id
				: _defaultCustomer.id;

			handleBookForSales(customerId, parseInt(selectedEvent));
		}
	};

	useEffect(() => {
		if (customersSummary && customersSummary.length > 0) {
			let _defaultCustomer = _.orderBy(
				customersSummary,
				(entry) => entry.fullName,
				'asc',
			)[0];
			let _findingCustomer = _.find(
				customersSummary,
				(entry) => entry.sapCode === queryProvider.get('customer'),
			);

			let customerId = _findingCustomer
				? _findingCustomer.id
				: _defaultCustomer.id;

			handleCustomer(customerId);

			if (showEventFilter && selectedEvent) {
				handleBookForSales(customerId, parseInt(selectedEvent));
			} else {
				handleOrdersSummary({
					customerId: customerId,
				});
			}
			handleFacilities(customerId);

			dispatch(
				initCustomer(_findingCustomer ? _findingCustomer : _defaultCustomer),
			);
		}
	}, [customersSummary, queryProvider.get('customer')]);

	useEffect(() => {
		if (!impersonateSalesGroup) dispatch(initSalesGroup(''));
	}, [impersonateSalesGroup, dispatch]);

	const bvCustomerOrders = useSelector(
		(state: RootState) => state.customerOrders.orderSummary,
	);

	return (
		<BVApplicationTemplate>
			{isAdmin && (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 12,
						marginBottom: 12,
						maxWidth: '100px',
					}}
				>
					<Switch
						checked={impersonateSalesGroup}
						onChange={setImpersonateSalesGroup}
					/>
					<span>Impersonate</span>

					<Select
						style={{ minWidth: 260 }}
						placeholder="Select a sales group"
						disabled={!impersonateSalesGroup}
						value={selectedGroup}
						options={(salesGroups ?? []).map((sg) => ({
							label: `${sg.name} - ${sg.code}`,
							value: sg.code ?? '',
						}))}
						loading={salesGroupsLoading}
						onChange={(value) => {
							dispatch(initSalesGroup(value === '' ? undefined : value));
							setSelectedGroup(bvSalesGroup);
						}}
					/>
				</div>
			)}
			<div className="customers-container">
				<BVCustomersGroup
					customers={customersSummaryByFilters}
					customersLoading={
						customersSummaryLoading || customersSummaryByFiltersLoading
					}
					dataFilters={dataFilter}
					onFilterChange={setDataFilter}
					events={events}
					eventsLoading={eventsLoading}
					showEventFilter={showEventFilter}
					onClick={(customer: CustomerSummary) => {
						handleCustomer(customer.id);

						if (showEventFilter && selectedEvent) {
							handleBookForSales(customer.id, parseInt(selectedEvent));
						} else {
							handleOrdersSummary({
								customerId: customer.id,
							});
						}
						handleFacilities(customer.id);

						dispatch(initCustomer(customer));
					}}
				/>

				{!customersSummaryLoading && (
					<BVOrdersGroup
						customer={customer}
						customerLoading={customerLoading}
						facilities={facilities}
						facilitiesLoading={facilitiesLoading}
						orders={bvCustomerOrders}
						ordersLoading={ordersSummaryLoading}
						customersSummaryByFiltersLoading={customersSummaryByFiltersLoading}
						bookedForSalesProducts={
							customersSummary && customersSummary.length === 0
								? []
								: bookedForSalesProducts
						}
						bookedForSalesProductsLoading={bookedForSalesProductsLoading}
						customerBookedForSalesEventRecap={customerBookedForSalesEventRecap}
						customerBookedForSalesEventRecapLoading={
							customerBookedForSalesEventRecapLoading
						}
						refreshBookedForSales={refreshBookedForSales}
					/>
				)}
			</div>
		</BVApplicationTemplate>
	);
};

export default CustomersPage;
